/**
 * MIT License
 * name: @mmears/monitor
 * version: 1.0.4-alpha.1
 * author: mmears-fe
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var logFactory = _interopDefault(require('@mmears/log'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * 获取页面性能数据
 */
var getTimingData = function () {
    var data = {};
    var timing = window.performance.timing;
    var startTime;
    var navV2Timing;
    if (window.performance && window.performance.getEntriesByType) {
        // 值可能为空
        navV2Timing = performance.getEntriesByType('navigation')[0];
    }
    if (navV2Timing) {
        startTime = navV2Timing.redirectStart;
        /** 网络链接时间 */
        // 页面重定向时间
        data.redirectTime = navV2Timing.redirectEnd - startTime;
        // dns查询时间
        data.dnsTime = navV2Timing.domainLookupEnd - navV2Timing.domainLookupStart;
        // tcp建连时间
        data.connectTime = navV2Timing.connectEnd - navV2Timing.connectStart;
        // 网络总耗时
        data.networkTime = navV2Timing.connectEnd - startTime;
        /** HTML接收时间 */
        // 发送http请求 到 开始收到响应的时间
        data.sendTime = navV2Timing.responseStart - navV2Timing.requestStart;
        // 接受页面响应的时间
        data.receiveTime = navV2Timing.responseEnd - navV2Timing.responseStart;
        // 请求HTML页面总耗时
        data.requestTime = navV2Timing.responseEnd - navV2Timing.requestStart;
        /** 前端渲染 */
        // domLoading时间, 可以理解为: 网络总耗时 + 请求HTML页面总耗时
        data.domLoadingTime =
            timing.domLoading - (timing.redirectStart === 0 ? timing.fetchStart : timing.redirectStart);
        // html解析时间
        data.domParseTime = timing.domComplete - timing.domLoading;
        // onload事件执行的时间
        data.loadEventTime = navV2Timing.loadEventEnd - navV2Timing.loadEventStart;
        // 前端总耗时, 从接收完HTML文档开始, 到 onload时间执行完成的时间
        data.frontendTime = timing.loadEventEnd - timing.domLoading;
        /**
         * 关键指标
         *
         * 如果JS添加了defer属性，那么 domInteractive 和 domContentLoaded 的时间差取决于JS的下载和执行时间。
         * defer JS表示告诉浏览器，这段JS在domInteractive后执行
         *
         * 一旦执行完defer JS，就会触发 domContentLoaded
         */
        // 首字节时间
        data.ttfbTime = navV2Timing.responseStart - startTime;
        // Dom tree 构建完成时间
        data.interactiveTime = navV2Timing.domInteractive;
        // 可操作时间
        data.domReadyTime = navV2Timing.domContentLoadedEventStart;
        // 页面加载总时间
        data.totalTime = navV2Timing.loadEventEnd - startTime;
    }
    else {
        startTime = timing.navigationStart;
        /** 网络链接时间 */
        // 页面重定向时间
        data.redirectTime = timing.redirectEnd - timing.redirectStart;
        // dns查询时间
        data.dnsTime = timing.domainLookupEnd - timing.domainLookupStart;
        // tcp建连时间
        data.connectTime = timing.connectEnd - timing.connectStart;
        // 网络总耗时
        data.networkTime = timing.connectEnd - startTime;
        /** HTML接收时间 */
        // 发送http请求 到 开始收到响应的时间
        data.sendTime = timing.responseStart - timing.requestStart;
        // 接受页面响应的时间
        data.receiveTime = timing.responseEnd - timing.responseStart;
        // 请求HTML页面总耗时
        data.requestTime = timing.responseEnd - timing.requestStart;
        /** 前端渲染 */
        // domLoading时间, 可以理解为: 网络总耗时 + 请求HTML页面总耗时
        data.domLoadingTime = timing.domLoading - startTime;
        // dom解析时间
        data.domParseTime = timing.domComplete - timing.domLoading;
        // onload事件执行的时间
        data.loadEventTime = timing.loadEventEnd - timing.loadEventStart;
        // 前端总耗时, 从接收完HTML文档开始, 到 onload时间执行完成的时间
        data.frontendTime = timing.loadEventEnd - timing.domLoading;
        /** 关键指标 */
        // 首字节时间
        data.ttfbTime = timing.responseStart - startTime;
        // Dom tree 构建完成时间
        data.interactiveTime = timing.domInteractive - startTime;
        // 可操作时间
        data.domReadyTime = timing.domContentLoadedEventStart - startTime;
        // 页面加载总时间
        data.totalTime = timing.loadEventEnd - startTime;
    }
    // 取整, 修改异常负数为0
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        var val = Math.round(data[key]);
        if (val < 0) {
            val = 0;
        }
        data[key] = val;
    }
    return data;
};

/**
 * 是否支持 performance level 1
 * TODO webkitPerformance
 */
var checkTimingLevel1 = function () {
    if (window.performance && window.performance.timing) {
        return true;
    }
    return false;
};

/**
 * 延迟时间
 */
var DELAY_TIME = 200;
/**
 * 页面性能监控
 */
// @ts-ignore
var PAGE_TIMING = 'PAGE_TIMING';
/**
 * 事件名称
 */
var eventName = 'monitor_log';
/**
 * 监控
 * 第一版, 不上报资源的性能指标数据
 */
var Monitor = /** @class */ (function () {
    function Monitor(config) {
        this.config = config || {};
        this.logger = logFactory({
            eventName: eventName,
            showLog: false,
            getAccount: function () {
                return 'monitor';
            }
        });
        this.isSupport = checkTimingLevel1();
        this.isInit = false;
    }
    /**
     * 初始化
     */
    Monitor.prototype.init = function () {
        if (!this.isSupport || this.isInit) {
            return;
        }
        // 页面已加载完成, 直接收集数据...
        if (document.readyState === 'complete') {
            this.reportTimingData();
            return;
        }
        this.isInit = true;
        window.addEventListener('load', this.onLoad.bind(this), false);
    };
    /**
     * 卸载
     */
    Monitor.prototype.destroy = function () {
        if (!this.isSupport) {
            return;
        }
        if (this.isInit) {
            window.removeEventListener('load', this.onLoad.bind(this), false);
            this.isInit = false;
        }
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };
    /**
     * 上报性能指标数据
     */
    Monitor.prototype.reportTimingData = function () {
        this.reportPageTimingData();
        this.reportResourceTimingData();
    };
    /**
     * 上报页面性能指标数据
     */
    Monitor.prototype.reportPageTimingData = function () {
        try {
            // 收集页面的timing数据
            var timingData = getTimingData();
            // 上报数据
            this.logger.info(__assign({ eventCode: PAGE_TIMING, message: '页面性能监控' }, timingData));
            // console.log('PAGE_TIMING', timingData);
        }
        catch (error) {
            console.error(error);
        }
    };
    /**
     * 上报资源性能指标数据
     * 第一版, 不上报资源的性能指标数据
     */
    Monitor.prototype.reportResourceTimingData = function () {
        // console.log('this.config', this.config);
        // 默认关闭
        if (!this.config.resourceRule || this.config.resourceRule === 'off') {
            return;
        }
        // try {
        //   const timingDataArray = getResourceTimingData();
        //
        //   timingDataArray.forEach((timingData) => {
        //     // 上报数据
        //     // this.logger.info({
        //     //   eventCode: RESOURCE_TIMING,
        //     //   message: '资源性能监控',
        //     //   ...timingData,
        //     // });
        //     console.log('RESOURCE_TIMING', timingData);
        //   });
        // } catch (error) {
        //   console.error(error);
        // }
    };
    /**
     * onLoad事件监听函数
     */
    Monitor.prototype.onLoad = function () {
        var _this = this;
        // 收集性能指标数据, 要异步去获取
        this.timer = setTimeout(function () {
            _this.reportTimingData();
        }, DELAY_TIME);
    };
    return Monitor;
}());

exports.default = Monitor;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mmears/monitor/dist/index.js
// module id = oUMR
// module chunks = 1